const date = [
    {
      startDate: 2025,
      endDate: 2026
    }
    ]
    
export default date;